import { useMsal } from "@azure/msal-react"
import styled from "@emotion/styled"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { Avatar, Button, Menu, MenuItem } from "@mui/material"
import theme from "css/theme/light"
import { allRoutes } from "generated/routes"
import React, { useContext } from "react"
import { useHistory } from "react-router"
import { AppContext } from "../components/AppContextProvider"
import { customerHasFeature } from "./customerHasFeature"
import { useTranslation } from "react-i18next"

function stringAvatar(name) {
  if (name !== undefined) {
    var names = name.split(" "),
      initials = names[0].substring(0, 1).toUpperCase()

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase()
    }
    return {
      children: `${initials}`
    }
  }
}

export const StyledButtonAvatarGroup = styled(Button)({
  background: theme.palette.secondary.main,
  color: theme.palette.primary["main"],
  marginRight: 15,
  height: "34px",
  padding: "4px 0px",
  borderRadius: "100vh",
  "&:hover": {
    background: theme.palette.secondary["500"]
  },
  textTransform: "none"
})
export const StyledAvatar = styled(Avatar)({
  background: theme.palette.primary["main"],
  color: "rgb(57 76 95)",
  padding: "16px",
  fontSize: theme.typography.bodyMedium.fontSize
})
export const StyledAvatarArrow = styled(ExpandMoreIcon)({
  margin: "0 4px 0 0",
  width: "1em",
  height: "1em",
  color: theme.palette.primary["light"]
})
export const LoginLogout = () => {
  const { t } = useTranslation()
  const { instance } = useMsal()
  const routerHistory = useHistory()
  const appContext = useContext(AppContext)
  const userName =
    appContext.isAuth && appContext.appUser.profile ? appContext.appUser.profile.name : "Inte inloggad"
  const [anchorEl, setAnchorEl] = React.useState(null)

  const openDropdown = Boolean(anchorEl)

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      {!appContext.isAuth ? (
        <Button
          color="inherit"
          onClick={() => {
            instance.loginRedirect()
          }}>
          Logga In
        </Button>
      ) : (
        <>
          <StyledButtonAvatarGroup
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
            size="small">
            <StyledAvatar sx={{ width: 20, height: 20, padding: "20px" }} {...stringAvatar(userName)} />
            <StyledAvatarArrow />
          </StyledButtonAvatarGroup>
          <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            keepMounted
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
            open={openDropdown}
            onClose={handleClose}>
            {customerHasFeature(appContext.appUser.customer, "CustomerAdmin") && (
              <MenuItem
                onClick={() => {
                  routerHistory.push(allRoutes.UserSettingsPasswordchange())
                  handleClose()
                }}>
                {t("global.change_password", "Change password")}
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                appContext.signOutUser()
              }}>
              {t("global.log_out", "Log out")}
            </MenuItem>
          </Menu>
        </>
      )}
    </>
  )
}
